/*MUTATIONS: THESE WILL ACTUALLY CHANGE STATES/DATA Accessed VIA - $store.commit([const] , [payload]);*/

export default{
    language: function(state , payload){
        state.language = payload
    },
    library: function(state , payload){
        state.library = payload
    },
    entryURL: function(state , payload){
        state.entryURL = payload
    },
    session_id: function(state , payload){
        state.session_id = payload
    },
    mode: function(state , payload){
        state.mode = payload
    },
    ready: function(state , payload){
        state.ready = payload
    },
    csrf: function(state , payload){
        state.csrf = payload
    },
    jwt: function(state , payload){
        state.jwt = payload;


        var jwt = payload;
        if(jwt){
            var token = parseJWT(jwt);
            this.dispatch('user',token.user);
        }
    
        function parseJWT (token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            return JSON.parse(window.atob(base64));
        } 
    },
    user: function(state , payload){
        state.user = payload
    },
    // language: function(state , payload){
    //     state.language = payload;
    // },
    busy: function(state , payload){
        if(payload==0){
            setTimeout(function(){
                state.busy = payload;
            },1000);
        }else{
            state.busy = payload;
        }
    },
    progressBar: function(state, payload){
        state.progressBar = payload;
    },
    window: function(state, payload){
        state.window = payload;
    },
    login: function(state, payload){
        state.overlays.login = payload;
    },
    loginRep: function(state, payload){
        state.overlays.loginRep = payload;
    },
    programAdmin: function(state, payload){
        state.overlays.programAdmin = payload;
    },
    programAdminQuickAccess: function(state, payload) {
        state.overlays.programAdminQuickAccess = payload;
    },
    contactUs: function(state, payload) {
        state.overlays.contactUs = payload;
    },
    editProfile: function(state, payload) {
        state.overlays.editProfile = payload;
    },
    siteRegulation: function(state, payload) {     
        state.overlays.siteRegulation = payload;
    },
    accountValidation: function(state, payload) {
        state.overlays.accountValidation = payload;
    },    
    accountValidationError: function(state, payload) {
        state.overlays.accountValidationError = payload;
    },    
    siteRegulationTargetTab: function(state, payload) {     
        state.siteRegulationTargetTab = payload;
    },    
    programs: function(state, payload){
        state.programs = payload;
    },
    programStatus: function(state, payload){
        state.programStatus = payload;
    },
    sessionLoggedDuration: function(state, payload){
        state.userSession.loggedDuration = payload;
    },
    sessionCreated: function(state, payload){
        state.userSession.created = payload;
    },
    sessionUpdated: function(state, payload){ 
        state.userSession.updated = payload;
    },
    sessionLoggedTrackingStarted: function(state, payload){
        state.userSession.loggedTrackingStarted = payload;
    },
    sessionLastActivity: function(state, payload){
        state.userSession.lastActivity = payload;
    },
    userSession: function(state, payload){
        state.userSession = payload;
    },
    V3_PortalState: function(state, payload){
        state.V3_PortalState = payload
    },
    setFeaturedProgram: function(state, payload) {
        state.featuredProgramId = payload
    }
    
}